import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_5 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_6 = { class: "text-sm text-gray-500 truncate" }
const _hoisted_7 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_8 = { class: "text-sm text-gray-900 truncate" }

import Sortable from 'sortablejs'
import { nextTick, onMounted, ref } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeuePagination from '@/components/neue/NeuePagination.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import NeueWell from '@/components/neue/NeueWell.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import SimpleEmptyState from '@/components/SimpleEmptyState.vue'
import api from '@/store/api'

const pageSize = 9

export default {
  __name: 'GiftCardList',
  setup(__props) {

const giftCardCols = [
  { width: 'minmax(120px, 2fr)' },
  { width: 'minmax(80px, 1fr)' },
  { width: 'minmax(80px, 1fr)' },
  { width: 'minmax(80px, 1fr)' },
  { width: '80px' }
]

const giftCards = ref([])
const page = ref(0)
const loading = ref(true)
const cards = ref(null)

const prevPage = ret => {
  page.value--
  ret()
}

const nextPage = ret => {
  page.value++
  ret()
}

const initSortable = () => {
  if (!cards.value) return
  new Sortable(cards.value, {
    onEnd(e) {
      const oldId = giftCards.value[e.oldIndex].id
      giftCards.value.sort((a, b) => a.attributes.order_value - b.attributes.order_value)
      let newOrder
      if (e.newIndex === 0) {
        newOrder = giftCards.value[0].attributes.order_value / 2
      } else if (e.newIndex === giftCards.value.length - 1) {
        newOrder = giftCards.value[giftCards.value.length - 1].attributes.order_value * 2
      } else {
        const calcCards = giftCards.value.filter(x => x.id !== oldId)
        const prev = calcCards[e.newIndex - 1]
        const next = calcCards[e.newIndex]
        newOrder = (prev.attributes.order_value + next.attributes.order_value) / 2
      }
      giftCards.value[e.oldIndex].attributes.order_value = newOrder
      giftCards.value.sort((a, b) => a.attributes.order_value - b.attributes.order_value)
      api.call('PUT', 'gift_cards/' + oldId, {
        gift_card: {
          order_value: newOrder
        }
      })
    }
  })
}

onMounted(async () => {
  const response = await api.call('GET', 'gift_cards')
  response.data.data.forEach(giftCard => {
    giftCards.value.push(giftCard)
  })
  giftCards.value.sort((a, b) => a.attributes.order_value - b.attributes.order_value)
  loading.value = false
  await nextTick()
  initSortable()
})

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Gift cards" }, {
        right: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/store/gift-cards/new" }, {
            default: _withCtx(() => [
              _createVNode(_component_NeueButton, { type: "primary" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("New", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (giftCards.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(NeueTablist, null, {
                        head: _withCtx(() => [
                          _createVNode(TablistHeader, null, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: giftCardCols,
                                header: ""
                              }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("div", null, "Discount", -1),
                                  _createElementVNode("div", null, "Status", -1),
                                  _createElementVNode("div", null, "Price", -1),
                                  _createElementVNode("div", null, "Value", -1),
                                  _createElementVNode("div", null, null, -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            ref_key: "cards",
                            ref: cards
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(giftCards.value.slice(page.value * pageSize, page.value * pageSize + pageSize), (giftCard) => {
                              return (_openBlock(), _createBlock(TablistRow, {
                                key: giftCard.id,
                                class: "cursor-move",
                                onClick: $event => (_ctx.$router.push('/store/gift-cards/' + giftCard.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: giftCardCols,
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(giftCard.attributes.gift_card_name), 1),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(giftCard.attributes.description), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass([
                              'px-2 capitalize inline-flex text-xs leading-5 font-semibold rounded-full',
                              giftCard.attributes.status === 'deleted'
                                ? 'bg-red-100 text-red-800'
                                : 'bg-green-100 text-green-800'
                            ])
                                        }, _toDisplayString(giftCard.attributes.status == 'deleted' ? 'Inactive' : giftCard.attributes.status), 3)
                                      ]),
                                      _createElementVNode("div", _hoisted_7, _toDisplayString(giftCard.attributes.price_amount.format), 1),
                                      _createElementVNode("div", _hoisted_8, _toDisplayString(giftCard.attributes.value_amount.format), 1),
                                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-right text-sm" }, [
                                        _createElementVNode("button", { class: "text-blue-600 hover:text-blue-900" }, "Edit")
                                      ], -1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ], 512)
                        ]),
                        _: 1
                      })
                    ]),
                    (giftCards.value.length > pageSize)
                      ? (_openBlock(), _createBlock(NeuePagination, {
                          key: 0,
                          size: giftCards.value.length,
                          from: page.value * pageSize + 1,
                          to: Math.min((page.value + 1) * pageSize, giftCards.value.length),
                          onPrev: prevPage,
                          onNext: nextPage
                        }, null, 8, ["size", "from", "to"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock(NeueWell, {
                    key: 1,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SimpleEmptyState, {
                        heading: "No gift cards yet",
                        description: "Get started by adding your first gift card",
                        icon: "ClipboardDocumentListIcon"
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}